module.exports = __webpack_public_path__ + "media/Quest_Game_UI_Bass_Tap_Button_Click_2_Snap.5f9a6ff5.wav";